import { AttrRange } from "../quill-selection/useAttributeInstances";
import { useCountWords } from "../quill-selection/useCountWords";
import { useSetInstanceError } from "./useSetInstanceError";

export const useDuplicateTokenInstanceValidation = (
  quill: any,
  activeAttribute: string,
  relevantInstances: AttrRange[],
  addErrorClass: boolean = true
) => {
  for (const instance of relevantInstances) {
    const text = quill.getText(instance.start, instance.length)?.trim();

    const wordCount = useCountWords(text);

    if (wordCount > 1) {
      if (addErrorClass) {
        useSetInstanceError(quill, activeAttribute, instance.value);
      }

      throw new Error("multiple-tokens-error");
    }
  }
};
